
                import "css-modules://src_components_cards_cards"
                export default {"Main":"_888038","Grey02":"_40d567","Inner":"_d5ef47","BG":"_b10fe3","Cards":"_6497f6","Card":"_db4c8c","Animator":"_f95a31","Active":"_b4f4ed","Index":"_bc5a75","Canvas":"_ca38c9","Title":"_9d1f8f","Subtitle":"_9098b8","Text":"_eaee3d"}
            